import React, { useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import { clearData, fetchSuspensionPaymentDetails } from "ducks/actions";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import styles from "./styles";
import { reduxForm } from "redux-form";
import SmartRender from "containers/SmartRender";
import Spinner, { styles as spinnerStyles } from "components/Spinner";
import { forms } from "utils/constants";
import {
  makeSuspendNumberFormInitialValues,
  makeSelectSuspensionDetails,
  makeSelectSuspensionStartDates,
  makeSelectSuspensionEndDates,
  makeSelectedSuspensionStartDate,
  makeSelectedSuspensionEndDate,
  makeSelectFormattedSuspensionNumber,
  makeSelectOrderRef,
  makeSelectSuspensionPaymentDetailFormattedAmount,
  makeSelectFormattedSuspensionTotalAmount,
  makeSelectSuspensionPaymentDetails,
  makeSelectedFormattedSuspensionStartDate,
  makeSelectedFormattedSuspensionEndDate,
  makeSelectPageValidations,
  makeSelectIsFetchingAnyData,
  makeSelectOrderDetails
} from "ducks/selectors";
import validate from "validations";
import { gotoUrl } from "utils/helpers";

const RequestSuspension = Component =>
  function Comp(props) {
    const {
      orderRef,
      suspensionDetails,
      selectedSuspensionStartDate,
      selectedSuspensionEndDate,
      fetchSuspensionPaymentDetails,
      isFetchingAnyData,
      orderDetails
    } = props;

    useEffect(
      () => {
        if (selectedSuspensionStartDate && selectedSuspensionEndDate) {
          fetchSuspensionPaymentDetails({
            orderRef,
            startDate: selectedSuspensionStartDate,
            endDate: selectedSuspensionEndDate,
            amount: get(suspensionDetails, "suspensionPricePerMonth")
          });
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [selectedSuspensionStartDate, selectedSuspensionEndDate]
    );

    useEffect(() => {
      if (
        !isEmpty(get(orderDetails, "eligibility")) &&
        !get(orderDetails, "eligibility.value")
      ) {
        gotoUrl("/manage/suspend-number/ineligible");
      }
    }, [orderDetails]);

    if (isFetchingAnyData)
      return <Spinner size={200} sx={spinnerStyles.fullPage} />;

    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  styles: () => styles,
  isFetchingAnyData: makeSelectIsFetchingAnyData(),
  formValidations: makeSelectPageValidations(forms.SUSPEND_NUMBER_FORM),
  orderRef: makeSelectOrderRef(),
  orderDetails: makeSelectOrderDetails(),
  suspensionDetails: makeSelectSuspensionDetails(),
  suspensionStartDates: makeSelectSuspensionStartDates(),
  suspensionEndDates: makeSelectSuspensionEndDates(),
  selectedSuspensionStartDate: makeSelectedSuspensionStartDate(),
  selectedSuspensionEndDate: makeSelectedSuspensionEndDate(),
  formattedSelectedNumber: makeSelectFormattedSuspensionNumber(),
  suspensionPaymentDetails: makeSelectSuspensionPaymentDetails(),
  suspensionPaymentDetailsTotalPrice: makeSelectSuspensionPaymentDetailFormattedAmount(),
  formattedSuspendNumberChargeTotalPrice: makeSelectFormattedSuspensionTotalAmount(),
  formattedSuspendNumberStartDate: makeSelectedFormattedSuspensionStartDate(),
  formattedSuspendNumberEndDate: makeSelectedFormattedSuspensionEndDate(),
  initialValues: makeSuspendNumberFormInitialValues()
});

export function mapDispatchToProps(dispatch) {
  return {
    clearData: key => {
      dispatch(clearData(key));
    },
    fetchSuspensionPaymentDetails: values => {
      const params = {
        order_ref: values.orderRef,
        start_date: values.startDate,
        end_date: values.endDate,
        amount: values.amount
      };

      dispatch(fetchSuspensionPaymentDetails(params));
    }
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  messageData: {
    suspendNumberChargeCardNetwork: get(
      stateProps,
      "suspensionPaymentDetails.card_network"
    ),
    suspendNumberChargeCardNumber: get(
      stateProps,
      "suspensionPaymentDetails.card_number"
    ),
    formattedSuspensionPaymentDetailsTotalPrice: get(
      stateProps,
      "suspensionPaymentDetailsTotalPrice.formattedPrice"
    ),
    formattedSuspendPhoneNumber: get(
      stateProps,
      "formattedSelectedNumber.formattedNumber"
    ),
    formattedSuspendNumberChargeTotalPrice: get(
      stateProps,
      "formattedSuspendNumberChargeTotalPrice.formattedPrice"
    ),
    formattedSuspendNumberStartDate: get(
      stateProps,
      "formattedSuspendNumberStartDate.label"
    ),
    formattedSuspendNumberEndDate: get(
      stateProps,
      "formattedSuspendNumberEndDate.label"
    )
  },
  isEmpty: isEmpty //to use in condition safe eval
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  reduxForm({
    form: forms.SUSPEND_NUMBER_FORM,
    validate: validate,
    destroyOnUnmount: false
  })
);

export default enhance(RequestSuspension(SmartRender));
